import type { fr } from './fr';

/** English dictionary — same keys as the French source. */
export const en: Record<keyof typeof fr, string> = {
  'header.language.fr': 'Français (FR)',
  'header.language.en': 'English (EN)',
  'header.profile': 'My profile',
  'header.settings': 'Account settings',
  'header.adminConsole': 'Admin console',
  'header.logout': 'Log out',
  'header.login': 'Log in',
  'guest.name': 'Guest',

  'nav.landing': 'Home',
  'nav.dashboard': 'Dashboard',
  'nav.search': 'Search & explore',
  'nav.profile': 'My profile & certifications',
  'nav.calls': 'Call log & transcripts',
  'nav.voiceAgent': 'Smart voice agent',
  'nav.pipeline': 'Sales pipeline CRM',
  'nav.services': 'Services & rates',
  'nav.quota': 'Usage & quotas',
  'nav.statistics': 'Statistics & performance',
  'nav.subscription': 'Subscription & plan',
  'nav.portfolio': 'Portfolio & gallery',
  'nav.calendar': 'Calendar & appointments',
  'nav.admin': 'Admin & compliance console',
  'nav.theme.dark': 'Enable dark mode',
  'nav.theme.light': 'Enable light mode',
  'nav.settings': 'General settings',

  'call.connecting': 'Connecting to the assistant…',
  'call.listening': 'Listening…',
  'call.thinking': 'The assistant is processing your request…',
  'call.speaking': 'The assistant is speaking…',
  'call.muteOn': 'Mute microphone',
  'call.muteOff': 'Unmute microphone',
  'call.mute': 'Mute',
  'call.unmute': 'Unmute',
  'call.transcript': 'Transcript',
  'call.transcriptTitle': 'Conversation transcript',
  'call.you': 'You',
  'call.hangup': 'Hang up',
  'call.close': 'Close',
  'call.sessionRequired': 'Sign-in required: log in to call this assistant.',
  'call.emptyTranscript': 'Speak — the transcript shows up in real time.',

  'settings.title': 'Settings',
  'settings.subtitle': 'Account preferences, applied across all your pages.',
  'settings.appearance': 'Appearance',
  'settings.darkMode': 'Dark mode',
  'settings.darkModeHint': 'Switches the whole interface to the dark theme.',
  'settings.language': 'Interface language',
  'settings.languageHint': 'Applied immediately across all pages and components.',
  'settings.notifications': 'Notifications',
  'settings.notificationsHint': 'Email alerts for calls, quotes and appointments.',
  'settings.account': 'Account',
  'settings.signedInAs': 'Signed in as',
  'settings.role': 'Role',
  'settings.logout': 'Log out',
  'settings.saved': 'Preferences saved.',

  'role.client': 'Client',
  'role.professional_owner': 'Professional',
  'role.professional_agent': 'Professional agent',
  'role.moderator': 'Moderator',
  'role.admin': 'Administrator',
};
